import ConfirmingView from "../../common/confirming";
import SuccessView from "../../common/success";
import FailureView from "../../common/failure";
import ErrorState from "../../../common/error";
import InfoState from "../../../common/info";
import EventLog from "../../../../logger/events";
import ProcessingState from "../../../common/processing";
import charge, { poll, validate } from "../../../../charge";
import ChargeSuccessful from "./handlers/onchargesuccessful";
import RequireValidation from "./handlers/onrequirevalidation";
import { USES_ORDER_REFERENCE } from "../../../../charge/flags";
import { parseChargeCallbacks } from "../../../../charge/utils";
import { isEmptyObject } from "../../../../fetcher/support/utils";
import BackgroundProcessingState from "../../../common/background_processing";
import { getChargeResponseError, traverseDataFields } from "../../../../charge/handler/helpers";
import PendingView from '../../common/pending';
import detectBrowserVersion from "../../../../utils/detect_browser_version";
import Device from "../../../../init/device";
import { fetchTranslatedString } from "../../../../../support/helpers";
import english from "../../../../../locales/en/init.json";
import french from "../../../../../locales/fr/init.json";
import portuguese from "../../../../../locales/pt/init.json";

import {
  callback,
  isFunction,
  isPlainObject,
  withProperties,
  objectWithAccessors,
  getValueAtPath,
  isString
} from "../../../../utils";
import handleFailureEvent from "../../../common/handle_failure_event";

let renderIframe = false;
let $$context, $$window, $processing = false;
// PWB (account EUR/GBP via Nuvion): when polling is started as soon as the
// customer is redirected to the partner page, $$accountStatusPollCancel holds
// the active poll's cancel fn and $$accountStatusPollStarted stays true so the
// vbvcomplete handler defers to that poll as the single source of truth.
let $$accountStatusPollCancel, $$accountStatusPollStarted = false;
const REDIRECT_CANCELLATION_ERROR_MESSAGE = 'payment.cancelled.error';

/**
 * NEVER CALL $charge.poll IMMEDIATELY AFTER CALLING $charge.cancel!!!!!
 */

function __handleRedirectionCleanup__() {
  $processing = false;
  $$context && (
    $$context.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing)),
    $$context = undefined
  );
  $$window && (isFunction($$window.close) && $$window.close(), $$window = undefined);
  self.focus();
  // Cancel any in-flight PWB poll and clear both latches, so a retry in the same
  // session isn't mistaken for an active poll (which would leave the customer
  // stuck on the confirming view with an orphaned poll still running).
  $$accountStatusPollCancel && (isFunction($$accountStatusPollCancel) && $$accountStatusPollCancel(), $$accountStatusPollCancel = undefined);
  $$accountStatusPollStarted = false;
  removeEventListener('message', __handleRedirectionPostMessage__);
}

function __handleRedirectionPostMessage__({ data, source }) {
  if ($$window && source === $$window) {
    // Ensure iframe handling mobile redirects is closed!
    if (renderIframe === true && document.querySelector('#iframe-checkout-v3-parent')) {
      document.querySelector('#iframe-checkout-v3-parent').remove();
    }
    const { name, respcode, respmsg } = isPlainObject(data) ? data : {};

    switch (name) {
      case 'mmoney-captcha-failed': {
        const { INIT_VIEW, dispatch: $dispatch } = $$context;

        const shouldRedirectOnFail = 
          getValueAtPath($$context.DATA, 'preferences[should_redirect_on_fail]') === true;
        const contextObject = { ...$$context, $$data: data };
        const $error = (isString(data.data) && data.data.trim()) || null;

        handleFailureEvent(
          shouldRedirectOnFail, FailureView, INIT_VIEW, contextObject, true, $error, $dispatch, ErrorState
        );

        __handleRedirectionCleanup__();
        break;
      }

      case 'mmoney-captcha-pending': {
        ErrorState.actions.updateErrorMessage('')
        PendingView && PendingView.activate.call({ ...$$context, $$data: data });
        __handleRedirectionCleanup__();
        break;
      }

      case 'vbvcomplete': {
        const paymentMethod = getValueAtPath($$context, 'STATE.method.current');
        if (['mobilemoneygh', 'mobilemoneymalawi', 'mobilemoneytanzania'].indexOf(paymentMethod) >= 0) {
          EventLog.customerReturnedFromVerificationPage()
        }

        if (['00'].indexOf(respcode) >= 0) {
            $$accountStatusPollCancel && (isFunction($$accountStatusPollCancel) && $$accountStatusPollCancel(), $$accountStatusPollCancel = undefined);
            SuccessView && SuccessView.activate.call({ ...$$context, $$data: data });
         } else {
          let skipError;
          const { INIT_VIEW, dispatch: $dispatch, $charge } = $$context;
          const paymentMethod = getValueAtPath($$context, 'STATE.method.current');
          const currentCurrency = getValueAtPath($$context, 'STATE.currency.current');

          if (paymentMethod === 'paypal') {
            try {
              const { vbvrespcode } = traverseDataFields(data, 'vbvrespcode');

              if (vbvrespcode === 'RR-C02') {
                SuccessView && SuccessView.activate.call({ ...$$context, $$data: data });
                EventLog.paypalPendingMerchantAction();
                skipError = true;
              }
            } catch (e) {}
          }

          if (paymentMethod === 'opay') {
            const { transactionobject }  = traverseDataFields(data, 'transactionobject');

            try {
              if (
                typeof transactionobject.status === 'string' && 
                transactionobject.status.toLowerCase() === 'failed' && 
                transactionobject.chargeResponseCode === '02'
              ) {
                const shouldRedirectOnFail = 
                  getValueAtPath($$context.DATA, 'preferences[should_redirect_on_fail]') === true;

                $$context.REDIRECT_URL = null;
                setTimeout(() => {
                  handleFailureEvent(shouldRedirectOnFail, FailureView, INIT_VIEW, { ...$$context, $$data: data });
                }, 0)
              }
            } catch (e) {}
          }

          if (paymentMethod === 'enaira') {
            try {
              const { vbvrespcode } = traverseDataFields(data, 'vbvrespcode');
              if (vbvrespcode === '02') {
                ConfirmingView && ConfirmingView.activate.call({ ...$$context, $$data: data });

                let pollConfig = {
                    onBegin() { },
                    onCancel() { pollConfig.onComplete() },
                    onFailure(data) {},
                    onSuccessful() { SuccessView && SuccessView.activate.call({ ...$$context, $$data: data }) },
                    onComplete() { /* self.console.log({ ...$this }) */ }
                }

                $charge.poll(pollConfig)
                skipError = true;
              }
            } catch (e) {}
          }

          if (paymentMethod === 'account' && ['EUR', 'GBP', 'ZAR'].includes(currentCurrency)) {
            try {
              const { vbvrespcode } = traverseDataFields(data, 'vbvrespcode');

              if ( data.data && data.data.status !== 'failed') {
                if (vbvrespcode === '02' || respcode === '02') {
                  if (['EUR', 'GBP'].includes(currentCurrency) && $$accountStatusPollStarted) {
                   // Status is already being polled since the customer was
                   // redirected to the partner page — that poll is the single
                   // source of truth, so don't start a second one here.
                      } else if (['EUR', 'GBP'].includes(currentCurrency)) {
                          const $ctx = $$context;

                    // Desktop & mobile: show confirming screen (with the
                    // "confirming your transaction" text), poll, then transition
                    // based on result.
                    ConfirmingView && ConfirmingView.activate.call({ ...$ctx, $$data: data });

                    $processing = false;
                    $ctx.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing));

                    $ctx.$charge.poll({
                      onSuccessful(pollData) {
                        SuccessView && SuccessView.activate.call({ ...$ctx, $$data: pollData });
                      },
                      onConfirming(pollData) {
                        PendingView && PendingView.activate.call({ ...$ctx, $$data: pollData });
                      },
                      onFailure(pollData) {
                        const shouldRedirectOnFail =
                          getValueAtPath($ctx.DATA, 'preferences[should_redirect_on_fail]') === true;
                        handleFailureEvent(
                          shouldRedirectOnFail, FailureView, $ctx.INIT_VIEW,
                          { ...$ctx, $$data: pollData }, true, null, $ctx.dispatch, ErrorState
                        );
                      }
                    });
                  } else {
                    // ZAR — preserve original behavior
                    PendingView && PendingView.activate.call({ ...$$context, $$data: data });
                  }
                }
              } else {
                const shouldRedirectOnFail = 
                getValueAtPath($$context.DATA, 'preferences[should_redirect_on_fail]') === true;
                shouldRedirectOnFail ? 
                  FailureView && FailureView.activate.call({ ...$$context, $$data: data }) :
                  INIT_VIEW(() => setTimeout(() => $dispatch(
                        ErrorState.actions.updateErrorMessage(
                          data.respmsg
                        )
                  ), 0));
              }
              skipError = true;
            } catch (e) {}
          }

          if (paymentMethod === 'paga') {
            try {
              const acctvalrespmsg = getValueAtPath(data, 'transactionobject.acctvalrespmsg');

              if (respcode === '02') {
                const shouldRedirectOnFail = 
                  getValueAtPath($$context.DATA, 'preferences[should_redirect_on_fail]') === true;

                handleFailureEvent(
                  shouldRedirectOnFail, FailureView, INIT_VIEW, { ...$$context, $$data: data }, true, acctvalrespmsg, $dispatch, ErrorState
                );
              }

              skipError = true;
            } catch (e) {}
          }

          // if (paymentMethod === 'barter') {
          //   try {
          //     const { acctvalrespcode } = traverseDataFields(data, 'acctvalrespcode');

          //     if (respcode === "06" || acctvalrespcode === "06") {
          //       INIT_VIEW(() => setTimeout(() => $dispatch(
          //         ErrorState.actions.updateErrorMessage(
          //           "barter.payment.cancelled"
          //         )
          //       ), 0));

          //       skipError = true;
          //     }
          //   } catch (e) {}
          // }

          if (skipError !== true) {
            const shouldRedirectOnFail = 
              getValueAtPath($$context.DATA, 'preferences[should_redirect_on_fail]') === true;
            const $error = (isString(respmsg) && respmsg.trim()) || null;
            
            handleFailureEvent(
              shouldRedirectOnFail, FailureView, INIT_VIEW, { ...$$context, $$data: data }, true, $error, $dispatch, ErrorState
            );
          }
        }

        __handleRedirectionCleanup__();
        break;
      }
    }
  }
}

function withChargeFunctions(contextObject) {
  if (!isPlainObject(this)) {
    throw new Error('Cannot retrieve functions without an execution context.');
  }

  if (!(isPlainObject(contextObject) && Object.isExtensible(contextObject))) {
    throw new Error('Cannot retrieve functions without appropriate context object.');
  }

  let $cancel;

  const $this = this;
  const { mode: flags } = $this;
  const useOrderReference = Boolean(flags & USES_ORDER_REFERENCE);

  const { charge, poll, validate, $context } = setupChargeFunctions({ flags });

  const onChargeSuccessful = ChargeSuccessful.call(contextObject);
  const onRequireValidation = RequireValidation.call(contextObject);

  const handleError = (function() {
  const $this = this;
    return function(err) {
      const { INIT_VIEW, dispatch: $dispatch } = $this;
      let $error;
  
      if (err) {
        $error = err instanceof Error
          ? err.message
          : getChargeResponseError(err) || err;
      }
  
      const originalError = $error;
  
      if (isPlainObject(this) && isPlainObject(this.data)) {
        ({ $error } = this.data);
        $error = $error || getChargeResponseError(this.data) || originalError;
      }
  
      const shouldRedirectOnFail =
        getValueAtPath(contextObject.DATA, 'preferences[should_redirect_on_fail]') === true;
  
      handleFailureEvent(shouldRedirectOnFail, FailureView, INIT_VIEW, contextObject, false, $error);
      const errorToCheck = (originalError || $error || '').toLowerCase();
      if (errorToCheck === 'failed to fetch' || errorToCheck === 'load failed') {
        setTimeout(() => {
          $dispatch(ErrorState.actions.updateErrorMessage("network.failed.error"));
        }, 100);
      } else if ($error) {
        setTimeout(() => {
          const feeData = getValueAtPath($context.$state.info.feeData);
          $dispatch(InfoState.actions.updateInfo({ fromCharge: true, feeData }));
        }, 100);
        setTimeout(() => {
          $dispatch(ErrorState.actions.updateErrorMessage($error));
        }, 100);
      }
    }
  }).call(contextObject);
  
  
  function onBegin() {
    contextObject.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = true));
    contextObject.dispatch(ProcessingState.actions.on());
    contextObject.dispatch(ErrorState.actions.updateErrorMessage());
  }

  function onDataResponse() {
    contextObject.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = false));
    contextObject.dispatch(ProcessingState.actions.off());
  }

  function onRequireRedirection() {
    try {
      const { url, reference } = this;
      contextObject.reference = reference;
      url.href && (contextObject.REDIRECT_URL = url);
    } catch (e) {}
  }

  function __onChargeOrValidateDataResponse() {
    onDataResponse.call(this);
    if (isPlainObject(this)) {
      const { data } = this;
      contextObject.$$data = withProperties(Object.create(null), { data });
    }
  }

  const $charge = withProperties(Object.create(null), {
    cancel(callback) {
      if ($processing && isFunction($cancel)) {
        return $cancel(callback);
      }
    },

    init(callbacks) {
      if (!$processing) {
        let data;

        ({ data, ...callbacks } = parseChargeCallbacks(callbacks, {
          onBegin,
          onChargeSuccessful,
          onChargeFailed: handleError,
          onComplete: onDataResponse,
          onDataResponse: __onChargeOrValidateDataResponse,
          onError: handleError,
          onRequireRedirection,
          onRequireValidation
        }));


        data = {
          amount: getValueAtPath($context.$chargeData, 'amount'),
          currency: getValueAtPath($context.$chargeData, 'currency'),
          country: getValueAtPath($context.$chargeData, 'country') || 'NG',
          ...isPlainObject($this.data) ? $this.data : {},
          ...isPlainObject(data) ? data : {}
        };

        !isEmptyObject(data) && charge(data, callbacks);
      }
    },

    validate(callbacks) {
      if (!$processing) {
        let data;

        ({ data, ...callbacks } = parseChargeCallbacks(callbacks, {
          onBegin,
          onComplete: onDataResponse,
          onDataResponse: __onChargeOrValidateDataResponse,
          onError: handleError,
          onValidateFailed: handleError
        }));

        data = {
          ...isPlainObject($this.data) ? $this.data : {},
          ...isPlainObject(data) ? data : {}
        };

        !isEmptyObject(data) && validate(data, callbacks);
      }
    },

    poll(callbacks) {
      if (!$processing) {
        const { order, charge } = isPlainObject(contextObject.reference) ? contextObject.reference : {};
        const reference = useOrderReference ? order : charge;

        if (reference) {
          const cancelPoll = poll(reference, parseChargeCallbacks(callbacks, {
            onBegin() { contextObject.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = true)) },
            onComplete: onDataResponse,
            onDataResponse(data) {
              // Override previous response data with poll status data.
              contextObject.$$data = data;
            },
            onError(err) {
              $cancel && $cancel();
              $processing = false;
            
              if (err instanceof RangeError) {
                // max polling count exceeded
                // uncomment this line to restart polling
                contextObject.$charge.poll(callbacks);
              } else {
                // uncomment this line to restart polling
                contextObject.$charge.poll(callbacks);
              }
            },
            // onError: handleError,
            onFailure: handleError
          }), contextObject);

          $cancel = function __cancelPoll__(cb) {
            if (isFunction(cancelPoll)) {
              cancelPoll();
              $cancel = undefined;
              contextObject.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = false));
              return (callback(cb)(), true);
            }
          };
        }
      }
    },

    redirect() {
      if (!$processing) {
        try {
          const url = contextObject.REDIRECT_URL;
          // Check to ensure apple payment method isn't the current payment method
          const isApplePay = getValueAtPath(contextObject, 'STATE.method.current') === 'applepay';
          const isGooglePay = getValueAtPath(contextObject, 'STATE.method.current') === 'googlepay';
          const isPaymob = getValueAtPath(contextObject, 'DATA.preferences[can_switch_to_paymob]') === true;
          // Name is historical: the is_token_io payload flag is gone, this now just means "EUR/GBP pay-with-bank".
          const isTokenDotIo = getValueAtPath(contextObject, 'STATE.method.current') === 'account' && ['GBP', 'EUR'].indexOf(getValueAtPath(contextObject, 'STATE.currency.current')) >= 0;
          const isPayWithBankZAR = getValueAtPath(contextObject, 'STATE.method.current') === 'account' && 
            getValueAtPath(contextObject, 'STATE.currency.current') === 'ZAR';
          const isOpay = getValueAtPath(contextObject, 'STATE.method.current') === 'opay';
          const isBankMono = getValueAtPath(contextObject, 'STATE.method.current') === 'account' && getValueAtPath(contextObject, 'STATE.currency.current') === 'NGN';
          const isMomoFranco = getValueAtPath(contextObject, 'STATE.method.current') === 'mobilemoneyfranco' && getValueAtPath(contextObject, 'STATE.currency.current') === 'XOF';
          // const currentLocaleFile = getValueAtPath(contextObject, 'STATE.locale') === 'en' ? english : french;
          const currentLocaleFile = getValueAtPath(contextObject, 'STATE.locale') === 'en' ? english : getValueAtPath(contextObject, 'STATE.locale') === 'fr' ? french : portuguese;
          const languageFileString = "iframe.close.text";
          let closeBtnText = fetchTranslatedString(currentLocaleFile, languageFileString);
          const isMomoFrancoOrangeMoneySN = isMomoFranco
            && getValueAtPath(contextObject, '$inputs[country].value.code') === 'SN'
            && getValueAtPath(contextObject, '$inputs[network].value.identifier') === 'Orangemoney';
          const isMomoGhana = getValueAtPath(contextObject, 'STATE.method.current') === 'mobilemoneyghana'
            && getValueAtPath(contextObject, 'STATE.currency.current') === 'GHS';
          let should_use_inline = detectBrowserVersion();
          renderIframe = !!(Device.isMobile || should_use_inline);

          if (
              renderIframe && 
              (isApplePay === false) && 
              (isGooglePay === false) && 
              (isPaymob === false) && 
              (isTokenDotIo === false) &&
              (isPayWithBankZAR === false) &&
              (isOpay === false) &&
              (isBankMono === false) &&
              (isMomoFrancoOrangeMoneySN === false) &&
              (isMomoGhana === false)
            ) {
            if (renderInlineIframeView(url.href, closeBtnText)) {
              // Gets the iframe's content from the parent element

              let iFrame = document.getElementById('_3dseciframe');
              $$window = iFrame.contentWindow;
              
              contextObject.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = true));
              $$context = contextObject;

              // Ensure that any error message is cleared when you redirect
              contextObject.dispatch(ErrorState.actions.updateErrorMessage());

              // Setup interval, to monitor when the redirect window has been closed
              // by the user — and update error state with the cancellation message.
              const interval = setInterval(() => {
                if (!$$window) {
                  clearInterval(interval);
                  return;
                }

                // Mobile: iOS reloads the iframe on input focus (keyboard), staling contentWindow — detect close by element removal, not $$window.closed.
                if (Device.isMobile) {
                  const iframeEl = document.getElementById('_3dseciframe');

                  if (iframeEl) {
                    if (iframeEl.contentWindow) $$window = iframeEl.contentWindow;
                    return;
                  }
                } else if (!$$window.closed) {
                  return;
                }

                const { INIT_VIEW, dispatch: $dispatch } = contextObject;

                clearInterval(interval);
                $$window = undefined;
                self.focus();
                $dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = false));

                // Update error message
                $dispatch(ErrorState.actions.updateErrorMessage(REDIRECT_CANCELLATION_ERROR_MESSAGE));
                
              }, 1000);

              addEventListener('message', __handleRedirectionPostMessage__);
            }
          } else {
          if ($$window = window.open(url.href, '_blank')) {
             contextObject.dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = true));
             $$context = contextObject;

             // Ensure that any error message is cleared when you redirect
             contextObject.dispatch(ErrorState.actions.updateErrorMessage());

              // For opay on iOS Safari, start polling for final status with 3-min timeout
              const isIOSSafari = Device.deviceType === 'IOS' && Device.browser.safari;
              if (isIOSSafari && isOpay) {
                const POLL_TIMEOUT = 3 * 60 * 1000; // 3 minutes
                let pollTimer;

                const { order, charge: chargeRef } = isPlainObject(contextObject.reference) ? contextObject.reference : {};
                const reference = useOrderReference ? order : chargeRef;

                if (reference) {
                  const cancelPoll = poll(reference, parseChargeCallbacks({
                    onBegin() {
                      pollTimer = setTimeout(() => {
                        cancelPoll && cancelPoll();
                        ConfirmingView && ConfirmingView.activate.call(contextObject);
                      }, POLL_TIMEOUT);
                    },
                    onSuccessful() {
                      clearTimeout(pollTimer);
                      SuccessView && SuccessView.activate.call(contextObject);
                    },
                    onComplete() {
                      clearTimeout(pollTimer);
                    },
                    onDataResponse(data) {
                      contextObject.$$data = data;
                    }
                  }), contextObject);
                }
              }

             // PWB (account EUR/GBP via Nuvion): begin polling for the
             // transaction status as soon as the customer is redirected to the
             // partner page, so Checkout reflects the final status even if the
             // customer never clicks "return to merchant" / never closes the tab.
             if (isTokenDotIo && !$$accountStatusPollCancel) {
               const { order, charge: chargeRef } = isPlainObject(contextObject.reference) ? contextObject.reference : {};
               const reference = useOrderReference ? order : chargeRef;

               if (reference) {
                 $$accountStatusPollStarted = true;
                 // Show the confirming screen (with the "confirming your
                 // transaction" text) on both desktop and mobile while the
                 // status resolves. The poll runs in the background and moves
                 // to the email page once a terminal status arrives.
                 ConfirmingView && ConfirmingView.activate.call(contextObject);

                 $$accountStatusPollCancel = poll(reference, parseChargeCallbacks({
                   onDataResponse(pollData) {
                     contextObject.$$data = pollData;
                   },
                   onSuccessful(pollData) {
                     $$accountStatusPollCancel = undefined;
                     SuccessView && SuccessView.activate.call({ ...contextObject, $$data: pollData });
                   },
                   onConfirming(pollData) {
                     PendingView && PendingView.activate.call({ ...contextObject, $$data: pollData });
                   },
                   onFailure(pollData) {
                     $$accountStatusPollCancel = undefined;
                     const shouldRedirectOnFail =
                       getValueAtPath(contextObject.DATA, 'preferences[should_redirect_on_fail]') === true;
                     handleFailureEvent(
                       shouldRedirectOnFail, FailureView, contextObject.INIT_VIEW,
                       { ...contextObject, $$data: pollData }, true, null, contextObject.dispatch, ErrorState
                     );
                   },
                   onComplete() {
                     $$accountStatusPollCancel = undefined;
                     $$accountStatusPollStarted = false;
                   }
                 }), contextObject);
               }
             }
              // Setup interval, to monitor when the redirect window has been closed
              // by the user — and update error state with the cancellation message.
              let closedTicks = 0;
              const interval = setInterval(() => {
                if (!$$window) {
                  clearInterval(interval);
                  return;
                }

                // Mobile: iOS can briefly report the popup closed on keyboard focus — require the closed state to persist two ticks before cancelling.
                if (!$$window.closed) {
                  closedTicks = 0;
                  return;
                }

                if (Device.isMobile && ++closedTicks < 2) {
                  return;
                }

                const { INIT_VIEW, dispatch: $dispatch } = contextObject;
                clearInterval(interval);
                $$window = undefined;
                self.focus();
                $dispatch(BackgroundProcessingState.actions.updateBackgroundProcessing($processing = false));
                  const _method = getValueAtPath(contextObject, 'STATE.method.current');
                  const _currency = getValueAtPath(contextObject, 'STATE.currency.current');
                  if (_method === 'account' && ['EUR', 'GBP'].includes(_currency)) {
                   PendingView && PendingView.activate.call(contextObject);
                   // Don't start a second poll if one is already running from
                   // when the customer was redirected to the partner page.
                   if (!$$accountStatusPollCancel && !$$accountStatusPollStarted) {
                     contextObject.$charge.poll(contextObject.pollConfig);
                   }
                  } else {
                  // Skip error message update for opay on iOS Safari or momofranco Orange Money Senegal on mobile
                  if (!(isIOSSafari && isOpay) && !(isMomoFrancoOrangeMoneySN && Device.isMobile) && !(isMomoGhana && Device.isMobile)) {
                    $dispatch(ErrorState.actions.updateErrorMessage(REDIRECT_CANCELLATION_ERROR_MESSAGE));
                  }
                }
              }, 1000);

              addEventListener('message', __handleRedirectionPostMessage__);
            }
          }
        } catch (e) {}
      }
    }
  });

  return withProperties(contextObject, { $charge });
}

function renderInlineIframeView (url, closeBtnText) {
  var parent = document.createElement('div');
  parent.setAttribute('id', 'iframe-checkout-v3-parent');
  parent.setAttribute('style', 'position:relative;background:#fff;top:0;left:0;bottom:0;right:0;border:none;visibility:visible;position:absolute;z-index:999999');
  parent.classList.add('iframe-loader');

  var _3dseciframe = document.createElement('iframe');

  var closeBtn = document.createElement("button");

  closeBtn.textContent = closeBtnText;
  closeBtn.setAttribute('style', 'font-weight:bold;background-color:#FF9B00;color:#fff;border-radius:3px;padding:3px;top:10px;right:15px;visibility:visible;position:absolute;z-index:999999999')
  closeBtn.classList.add('_iframe__close');

  _3dseciframe.setAttribute('width', '100%');
  _3dseciframe.setAttribute('height', '100%');
  _3dseciframe.setAttribute('id', '_3dseciframe');
  _3dseciframe.src = url;
  _3dseciframe.onload = function() {
    parent.classList.remove('iframe-loader')
  }

  parent.appendChild(_3dseciframe);
  parent.appendChild(closeBtn);

  document.body.appendChild(parent)

  closeBtn.addEventListener('click', () => {
    document.getElementById('iframe-checkout-v3-parent').remove();
    setTimeout(() => ($$window.closed = true), 100)
  })

  return parent;
};

function setupChargeFunctions(data, store) {
  if (data && store) {
    setupChargeFunctions = function __setupChargeFunctions__(contextData) {
      const $context = objectWithAccessors({
        $chargeData: () => data,
        $state: () => store.getState()
      }, false);

      Object.freeze(withProperties($context, {
        ...(isPlainObject(contextData) ? contextData : {})
      }));

      return Object.freeze(
        withProperties(Object.create(null), {
          $context,
          charge: charge.bind($context),
          poll: poll.bind($context),
          validate: validate.bind($context)
        })
      );
    }
  }
}

export { withChargeFunctions, $processing };
export default setupChargeFunctions;